module.exports = __webpack_public_path__ + "static/media/SFProText-Regular.85bd46c1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProText-Regular.ttf
// module id = 2548
// module chunks = 7